export var QueryFrame;
(function (QueryFrame) {
    function getAddressingDimensions(query, frame) {
        return getAddressingFields(query, frame).filter((field) => field.source === "FIELD" && field.role === "DIMENSION");
    }
    QueryFrame.getAddressingDimensions = getAddressingDimensions;
    function getAddressingFields(query, frame) {
        var _a;
        if (frame.type !== "CUSTOM") {
            return flatten(getAddressingChannels(query, frame));
        }
        const sorts = (_a = query.sorts) !== null && _a !== void 0 ? _a : [];
        const fields = flatten([
            query.column,
            query.x,
            query.row,
            query.y,
            query.marks,
        ]);
        return distinctByAlias(frame.address.flatMap((formula) => {
            const matchingFields = fields.filter((field) => {
                return (field.source === "FIELD" &&
                    field.formula.source === formula);
            });
            const discrete = [];
            const nested = [];
            const rest = [];
            for (const field of matchingFields) {
                if (sorts.some((sort) => sort.type === "BY_NESTED" &&
                    sort.field.alias === field.alias)) {
                    nested.push(field);
                }
                else if (field.type === "DISCRETE") {
                    discrete.push(field);
                }
                else {
                    rest.push(field);
                }
            }
            const result = flatten([nested, discrete, rest]);
            return result;
        }));
    }
    QueryFrame.getAddressingFields = getAddressingFields;
    function getAddressingChannels(query, frame) {
        switch (frame.type) {
            case "CELL": {
                return [];
            }
            case "CUSTOM": {
                return [query.column, query.x, query.row, query.y, query.marks];
            }
            case "PANE": {
                switch (frame.address) {
                    case "ACROSS": {
                        return [query.x];
                    }
                    case "ACROSS_DOWN": {
                        return [query.y, query.x];
                    }
                    case "DOWN": {
                        return [query.y];
                    }
                    case "DOWN_ACROSS": {
                        return [query.x, query.y];
                    }
                }
            }
            case "TABLE": {
                switch (frame.address) {
                    case "ACROSS": {
                        return [query.column, query.x];
                    }
                    case "ACROSS_DOWN": {
                        return [query.row, query.y, query.column, query.x];
                    }
                    case "DOWN": {
                        return [query.row, query.y];
                    }
                    case "DOWN_ACROSS": {
                        return [query.column, query.x, query.row, query.y];
                    }
                }
            }
        }
    }
    function getPartitioningDimensions(query, frame) {
        return getPartitioningFields(query, frame).filter((field) => field.source === "FIELD" && field.role === "DIMENSION");
    }
    QueryFrame.getPartitioningDimensions = getPartitioningDimensions;
    function getPartitioningFields(query, frame) {
        const addressingFormulas = new Set(getAddressingFields(query, frame).map((addrField) => addrField.formula.source));
        const channels = [query.column, query.x, query.row, query.y, query.marks];
        return flatten(channels).filter((partField) => !addressingFormulas.has(partField.formula.source));
    }
    QueryFrame.getPartitioningFields = getPartitioningFields;
    function flatten(items) {
        return items.flat().filter((field) => field !== undefined);
    }
    function distinctByAlias(fields) {
        const seen = new Set();
        return fields.filter((field) => seen.size !== seen.add(field.alias).size);
    }
})(QueryFrame || (QueryFrame = {}));
